import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'hooks/useAppDispatchSelector';
import { setModal } from 'store/features/modelSlice';
import DarkButton from 'components/common/buttons/dark-btn';
import PrimaryDarkButton from 'components/common/buttons/primary-dark-btn';
import { getRedirectedURL } from 'helpers/utils';

const AppointmentRequestPopup: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { modal } = useAppSelector(state => state.modal);
  const count = modal?.content?.count || 0;

  const navigateTo = (path: string) => {
    window.location.hash = `#${path}`;
  };

  const handleYes = () => {
    dispatch(setModal({ type: null, content: {} }));
    navigateTo('/workshop-appointments/requests-list');
  };

  const handleNo = () => {
    dispatch(setModal({ type: null, content: {} }));
    const url = getRedirectedURL();
    navigateTo(url);
  };

  return (
    <div className="flex flex-col items-center justify-center p-4 max-w-sm">
      <h2 className="text-xl font-bold text-center mb-4 text-primary">
        {t('workshopAppointment.newRequestsPopupTitle')}
      </h2>
      <p className="text-center text-grey9 mb-6">
        {t('workshopAppointment.newRequestsPopupMessage', { count })}
      </p>
      <div className="flex items-center justify-center w-full gap-4">
        <PrimaryDarkButton label={t('workshopAppointment.yes')} onClick={handleYes} width="w-24" />
        <DarkButton label={t('workshopAppointment.no')} onClick={handleNo} width="w-24" />
      </div>
    </div>
  );
};

export default AppointmentRequestPopup;